import { db } from "../../server";
import { interpolate } from "../helpers/stringHelper";
import { paths } from "../constants/dbPaths";
import { DetectBrand } from "../../mixins/brandDetector";
import { instance } from "../apiclient";
import { logger } from "../Logger";
import { DateTime } from "luxon";

export function getTrackingOrder(userId, orderId, storeId) {
  if (DetectBrand.methods.isBranded()) {
    return db.doc(interpolate(paths.TrackingOrderDoc, userId, orderId));
  } else {
    return db.doc(interpolate(paths.TrackingOrderDoc, storeId, orderId));
  }
}

export function getOrderHistory(userId, orderId, storeId) {
  if (DetectBrand.methods.isBranded()) {
    return db.doc(interpolate(paths.OrderHistoryDoc, userId, orderId));
  } else {
    return db.doc(interpolate(paths.OrderHistoryDoc, storeId, orderId));
  }
}

export function cancelOrder(order, ScheduledTime) {
  var data = {
    StoreID: order.StoreID, //"2016949",
    OnlineOrderUserIdentifier: order.OnlineOrderUserIdentifier,
    Source: order.Source,
    SourceReference_ID: order.SourceReference_ID,
    SourceReferenceNumber: order.SourceReferenceNumber,
    OrderNumber: order.OrderNumber,
    DisplayName: "",
    ScheduledTime: ScheduledTime,
  };
  var status = 12;
  return instance.put(`trackingorders/${order.UDID}/status/${status}`, data);
}

export async function getTrackingOrderData(userId, orderId, storeId) {
  try {
    if (DetectBrand.methods.isBranded()) {
      const docRef = db
        .collection('OnlineOrdersInfo')
        .doc(userId)
        .collection("TrackingOrders")
        .doc(orderId);
      const doc = await docRef.get();
      if (doc.exists) {
        return doc.data();
      } else {
        const historyRef = db
          .collection('OnlineOrdersInfo')
          .doc(userId)
          .collection("HistoryOrders")
          .doc(orderId);
        const history = historyRef.get();
        if (history.exists) {
          return doc.data();
        }
      }
      return null;
    }
    // for general stores
    const docRef = db
      .collection(paths.StoreCollection)
      .doc(storeId)
      .collection("TrackingOrders")
      .doc(orderId);
    const doc = await docRef.get();
    if (doc.exists) {
      return doc.data();
    }
    return null;
  } catch (error) {
    logger.log(error);
    return null;
  }
}
export async function getRecentOrdersOnTable(storeid, table, minutes) {
  const result = [];
  const time = DateTime.local().minus({ minutes: minutes }).toJSDate();
  const query = await db
    .collection(paths.StoreCollection)
    .doc(storeid)
    .collection("TrackingOrders")
    .where("CreatedOn", ">", time)
    .get();
  if (!query.empty) {
    query.forEach((doc) => {
      const order = doc.data();
      if (
        order.Tables &&
        order.Tables.length > 0 &&
        order.Tables.some((tb) => tb.Name === table.toString())
      ) {
        result.push(order);
      }
    });
  }
  return result;
}

export function listenTrackingOrder(userId, orderId, storeId) {
  try {
    if (DetectBrand.methods.isBranded()) {
      return db
        .collection('OnlineOrdersInfo')
        .doc(userId)
        .collection("TrackingOrders")
        .doc(orderId);      
    }
    // for general stores
    return db
      .collection(paths.StoreCollection)
      .doc(storeId)
      .collection("TrackingOrders")
      .doc(orderId);
  } catch (error) {
    logger.log(error);
    return null;
  }
}

export function setUpTrackingOrderListener(that) {
  if (that.storeid) {
    const udid = that.orderIdentifier;
    const userID = that.user ? that.user.id : that.guestUserIdentifier;
    const dbRef = listenTrackingOrder(userID, udid, that.storeid);

    if (dbRef) {
      that.unsubscribe = dbRef.onSnapshot(doc => {
        if (doc.exists) {
          that.$router.push({
            name: "completeorder",
            params: {
              storeid: that.storeid,
              orderid: udid,
              userid: userID,
              createUserForGuest: false,
              selectedCompanyId: that.storeid,
            },
          });
        }
      });
    }
  }
}
